import { ADD_MIS_HOLIDAYS, GET_MIS_HOLIDAYS_LIST, GET_MIS_SINGLE_HOLIDAYS_LIST } from "../actions/MisHolidayActions";


const initialState = {// initialize states
    MisList: [],
    MisSingleHoliday: [],
};

const HolidayReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_MIS_HOLIDAYS_LIST: { // save holiday list into state
            return { ...state, MisList: action.payload.data ? action.payload.data : [] };
        }
        case GET_MIS_SINGLE_HOLIDAYS_LIST: { // save single holiday data into state
            return { ...state, MisSingleHoliday: action.payload.data ? action.payload.data : [] };
          }
        case ADD_MIS_HOLIDAYS: { 
            return { ...state, };
          }
        default: {
            return {
                ...state,
            };
        }
    }
};

export default HolidayReducer;
